import React from 'react';
import '../../styles/Boutique/Cart.css';

const Cart = ({ isOpen, closeCart, cart, removeFromCart, changeQuantity, openPaymentModal }) => {
  if (!isOpen) return null;

  const calculateTotal = () => {
    const subTotal = cart.reduce((total, item) => total + item.price * item.quantity, 0);
    const totalWeight = cart.reduce((total, item) => total + item.weight * item.quantity, 0);
    let shippingCost = 0;

    if (cart.length === 1 && cart[0].packagingFee) {
      shippingCost = cart[0].packagingFee;
    } else {
      if (totalWeight <= 250) {
        shippingCost = 6.75;
      } else if (totalWeight <= 500) {
        shippingCost = 8.85;
      } else if (totalWeight <= 750) {
        shippingCost = 10.65;
      } else if (totalWeight <= 1000) {
        shippingCost = 11.40;
      } else if (totalWeight <= 2000) {
        shippingCost = 12.70;
      } else if (totalWeight <= 5000) {
        shippingCost = 20.60;
      }
    }

    return { subTotal, shippingCost, total: subTotal + shippingCost };
  };

  const { subTotal, shippingCost, total } = calculateTotal();

  return (
    <div className={`modal ${isOpen ? 'show' : ''}`}>
      <div className="modal-content">
        <span className="close" onClick={closeCart}>&times;</span>
        <div id="cartItems">
          {cart.map((item, index) => (
            <div key={index} className="cart-item">
              <img src={item.image} alt={item.name} />
              <div className="cart-item-details">
                <h3>{item.name}</h3>
                <p>Prix: {item.price.toFixed(2)} €</p>
                {item.selectedSize && <p>Taille: {item.selectedSize}</p>}
                <p>Quantité: {item.quantity}</p>
                <p>Sous-total: {(item.price * item.quantity).toFixed(2)} €</p>
                <div className="quantity-controls">
                  <button onClick={() => changeQuantity(item.name, -1)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => changeQuantity(item.name, 1)}>+</button>
                  <button onClick={() => removeFromCart(index)}>🗑️</button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {cart.length === 0 ? (
          <div id="emptyCartMessage">Le panier est vide.</div>
        ) : (
          <div id="cartTotal">
            <p id="subTotal">Sous-total : {subTotal.toFixed(2)} €</p>
            <p id="shippingFee">Frais de livraison : {shippingCost.toFixed(2)} €</p>
            <h3>Total du panier : {total.toFixed(2)} €</h3>
            <span> En validant votre commande, vous acceptez nos <a href="cgv.html" target="_blank" style={{ marginTop: '2rem', fontWeight: '500', textDecoration: 'none', color: 'var(--tdm-blue)' }}>conditions générales de vente</a>.</span>
            <button className="checkout-button" onClick={openPaymentModal}>Valider ma commande</button>
            <button className="back-to-shop-button" onClick={closeCart}>Retour à la boutique</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;